import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';
import { STATUS_STYLE } from './StatusBadge';

const NoRequests = ({ statusFilter, setShowCreate }) => {
  const { t } = useTranslation();
  const statusLabel = statusFilter && STATUS_STYLE[statusFilter]?.tKey ? t(STATUS_STYLE[statusFilter].tKey).toLowerCase() : '';
  return (
    <div style={{ textAlign: 'center', padding: 60 }}>
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 16,
          background: `${S.burgundy}12`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
        }}
      >
        <Icon name='pen-tool' color={S.burgundy} size={24} />
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, color: S.textPrimary, marginBottom: 6 }}>{t('screens.esign.noRequestsTitle')}</div>
      <div style={{ fontSize: 14, color: S.textMuted, marginBottom: 20 }}>
        {statusFilter ? t('screens.esign.noRequestsForFilter', { status: statusLabel }) : t('screens.esign.noRequestsFirst')}
      </div>
      <button
        onClick={() => setShowCreate(true)}
        style={{ padding: '10px 24px', background: S.burgundy, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
      >
        {t('screens.esign.newRequest')}
      </button>
    </div>
  );
};

export default NoRequests;
